import { createSelector } from '@reduxjs/toolkit'

import { referencesSelectors } from './references'

const editSchedulePageState = (state) => state.editSchedulePage

const isSelectedValueValid = (selectedId, options) => {
    if (!selectedId) return false

    return options.some((option) => String(option.value) === String(selectedId))
}

const selectEditScheduleFilters = createSelector(
    [
        (state) => editSchedulePageState(state).viewMode,
        (state) => editSchedulePageState(state).selectedGroupId,
        (state) => editSchedulePageState(state).selectedTeacherId,
        (state) => editSchedulePageState(state).dateFrom,
        (state) => editSchedulePageState(state).dateTo,
        (state) => editSchedulePageState(state).selectedRoomId,
        (state) => editSchedulePageState(state).selectedBuildId,
        (state) => editSchedulePageState(state).selectedClassTypeId,
        (state) => editSchedulePageState(state).selectedSubjectId,
        (state) => editSchedulePageState(state).currentPage,
        (state) => editSchedulePageState(state).pageSize,
    ],
    (
        viewMode,
        selectedGroupId,
        selectedTeacherId,
        dateFrom,
        dateTo,
        selectedRoomId,
        selectedBuildId,
        selectedClassTypeId,
        selectedSubjectId,
        currentPage,
        pageSize
    ) => ({
        viewMode,
        selectedGroupId,
        selectedTeacherId,
        dateFrom,
        dateTo,
        selectedRoomId,
        selectedBuildId,
        selectedClassTypeId,
        selectedSubjectId,
        currentPage,
        pageSize,
    })
)

export const editSchedulePageSelectors = {
    dateFrom: (state) => editSchedulePageState(state).dateFrom,
    dateTo: (state) => editSchedulePageState(state).dateTo,
    viewMode: (state) => editSchedulePageState(state).viewMode,
    selectedGroupId: (state) => editSchedulePageState(state).selectedGroupId,
    selectedTeacherId: (state) => editSchedulePageState(state).selectedTeacherId,
    selectedRoomId: (state) => editSchedulePageState(state).selectedRoomId,
    selectedBuildId: (state) => editSchedulePageState(state).selectedBuildId,
    selectedClassTypeId: (state) => editSchedulePageState(state).selectedClassTypeId,
    selectedSubjectId: (state) => editSchedulePageState(state).selectedSubjectId,
    currentPage: (state) => editSchedulePageState(state).currentPage,
    pageSize: (state) => editSchedulePageState(state).pageSize,
    showMoreOptions: (state) => editSchedulePageState(state).showMoreOptions,
    form: (state) => editSchedulePageState(state).form,
    initialForm: (state) => editSchedulePageState(state).initialForm,
    editingId: (state) => editSchedulePageState(state).editingId,
    isCreating: (state) => editSchedulePageState(state).isCreating,
    showDeleteModal: (state) => editSchedulePageState(state).showDeleteModal,
    deleteClassId: (state) => editSchedulePageState(state).deleteClassId,
    showCloseEditorModal: (state) => editSchedulePageState(state).showCloseEditorModal,
    pendingAction: (state) => editSchedulePageState(state).pendingAction,
    isFormDirty: (state) => {
        const page = editSchedulePageState(state)

        return JSON.stringify(page.form) !== JSON.stringify(page.initialForm)
    },
    isEditorOpen: (state) => {
        const page = editSchedulePageState(state)

        return page.isCreating || page.editingId !== null
    },
    filters: selectEditScheduleFilters,
    isValidGroupValue: (state) =>
        isSelectedValueValid(
            editSchedulePageState(state).selectedGroupId,
            referencesSelectors.groupOptions(state)
        ),
    isValidTeacherValue: (state) =>
        isSelectedValueValid(
            editSchedulePageState(state).selectedTeacherId,
            referencesSelectors.teacherOptions(state)
        ),
}
